import {getPlaceholderPhotoSrc} from "../../utils/stockLabel";

export default function NoPhoto({hasStock}: {hasStock?: boolean}) {
    return (
        <div className="d-flex col-12 col-md-5 flex-column-reverse flex-md-row left-product product__left">
            <div className="left-product__slider-big">
                {hasStock !== undefined && <img
                    src={getPlaceholderPhotoSrc(hasStock)}
                    className={'w-100'}
                    alt={hasStock ? 'Нет фото' : 'Скоро в продаже'}
                />}
            </div>
        </div>
    )
}
